import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

type Props = { isActive: boolean } & HTMLAttributes<HTMLButtonElement>
export const ButtonItem = ({ className, isActive, ...props }: Props) => {
  const buttonStyle = {
    'bg-white text-primary hover:bg-white shadow-sm': isActive,
  }
  return (
    <button
      className={cn(
        'relative flex h-6 items-center justify-center gap-1 rounded-md border-none bg-transparent px-4 text-sm text-gray-500 hover:bg-black/5 focus:outline-none active:outline-none',
        buttonStyle,
        className
      )}
      type="button"
      {...props}
    />
  )
}
